import script from "./PageTop.vue?vue&type=script&setup=true&lang=js"
export * from "./PageTop.vue?vue&type=script&setup=true&lang=js"

import "./PageTop.vue?vue&type=style&index=0&id=7fbfa96c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fbfa96c"]])

export default __exports__